// Lightweight haptic helper. Uses the Vibration API where available and
// silently no-ops on desktop / unsupported browsers. The `intensity` maps to
// a duration in milliseconds so we can keep every tap consistent.
//
// Respects a user preference stored in localStorage under `haptics_enabled`
// (defaults to ON) so we can wire a settings toggle later without touching
// call sites.

const KEY = "haptics_enabled";

const DURATIONS = {
  light: 8,   // bottom-nav taps, small chips
  medium: 15, // primary actions
  heavy: 25,  // destructive confirms
};

function enabled() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw === null ? true : raw === "true";
  } catch {
    return true;
  }
}

export function setHapticsEnabled(on) {
  try { localStorage.setItem(KEY, on ? "true" : "false"); } catch { /* ignore */ }
}

export function hapticsEnabled() { return enabled(); }

export function hapticTap(intensity = "light") {
  if (!enabled()) return;
  if (typeof navigator === "undefined") return;
  const vibrate = navigator.vibrate?.bind(navigator);
  if (!vibrate) return;
  const ms = DURATIONS[intensity] ?? DURATIONS.light;
  try { vibrate(ms); } catch { /* ignore */ }
}
